import type { MembershipPlan, PlanFeature, PlanFeatureId } from "@/types/membership";

/**
 * All available plan features
 */
export const PLAN_FEATURES: Record<PlanFeatureId, PlanFeature> = {
	thousands_of_liquidity_pools: {
		id: "thousands_of_liquidity_pools",
		name: "Thousands of Liquidity Pools",
	},
	uniswap_v3_v4_protocols: {
		id: "uniswap_v3_v4_protocols",
		name: "Uniswap v3 & v4 Protocols",
	},
	ethereum_7_networks: {
		id: "ethereum_7_networks",
		name: "Ethereum + 7 Networks",
	},
	"1_day_performance": {
		id: "1_day_performance",
		name: "1-Day Performance",
	},
	"7_day_performance": {
		id: "7_day_performance",
		name: "7-Day Performance",
	},
	"30_day_performance": {
		id: "30_day_performance",
		name: "30-Day Performance",
	},
	range_analyzer: {
		id: "range_analyzer",
		name: "Range Analyzer",
	},
	income_calculator: {
		id: "income_calculator",
		name: "Income Calculator",
	},
	csv_data_downloads: {
		id: "csv_data_downloads",
		name: "CSV Data Downloads",
	},
	priority_support: {
		id: "priority_support",
		name: "Priority Support",
	},
	export_pool_recommendations: {
		id: "export_pool_recommendations",
		name: "Expert Pool Recommendations",
	},
	favorites: {
		id: "favorites",
		name: "Favorites",
		description: "Save and manage your favorite liquidity pools",
	},
};

/** Sellable tiers only — legacy `max` in DB maps to Pro for entitlements */
export const MEMBERSHIP_PLANS: Record<"free" | "pro", MembershipPlan> = {
	free: {
		id: "free",
		name: "Free",
		price: {
			monthly: 0,
			yearly: 0,
		},
		features: [
			"thousands_of_liquidity_pools",
			"uniswap_v3_v4_protocols",
			"ethereum_7_networks",
			"1_day_performance",
		],
	},
	pro: {
		id: "pro",
		name: "Pro",
		price: {
			monthly: 97,
			yearly: 497,
		},
		features: [
			"thousands_of_liquidity_pools",
			"uniswap_v3_v4_protocols",
			"ethereum_7_networks",
			"1_day_performance",
			"7_day_performance",
			"30_day_performance",
			"range_analyzer",
			"income_calculator",
			"csv_data_downloads",
			"priority_support",
			"export_pool_recommendations",
			"favorites",
		],
		featured: true,
	},
};

export function getSellableMembershipPlan(planId: string): MembershipPlan | undefined {
	const tier = planId === "max" ? "pro" : planId;
	if (tier === "free" || tier === "pro") {
		return MEMBERSHIP_PLANS[tier];
	}
	return undefined;
}
